export const FoodOrderingFeatureFlagId = "30b79e69-62ad-4f9d-b7a4-befaa12e9c86";
export const AIAnsweringFeatureFlagId = "a3d1f8ce-3f0a-4dbe-b3b5-653d3f16b022";
export const GenAIFoodOrdering = "4a8e0e9f-82bb-4504-b288-58e1d755cecb";
export const OutboundCallFeatureFlagId = "78bcb04d-c8d2-4cbb-adab-1816f9ff2043";
export const HealthcareSchedulingFeatureFlagId = "90473acb-7f54-453a-933b-4602f901741f";
export const DeepAnalysisFeatureFlagId = "e7d89e43-5534-4a27-9952-4c813f2d8b6e";
export const DisableLegacyCheckoutFlowFeatureFlagId = "4c87ece8-08b2-4fff-bc88-bfda6ff2b4a6";

export const DeepAnalysisFeatureFlag = {
    id: DeepAnalysisFeatureFlagId,
    name: "Deep Analysis",
};

export const GENERATIVE_CALL_REVIEW_FEATURE_FLAG_IDS = [FoodOrderingFeatureFlagId, GenAIFoodOrdering, HealthcareSchedulingFeatureFlagId, OutboundCallFeatureFlagId];

export const TAG_FEATURE_FLAG_OPTIONS = [
    { label: "Food Ordering", value: FoodOrderingFeatureFlagId },
    { label: "Healthcare", value: HealthcareSchedulingFeatureFlagId },
    { label: "Outbound Calling", value: OutboundCallFeatureFlagId },
];
